import { render, staticRenderFns } from "./HomeMakAndGreet.vue?vue&type=template&id=87b9ec58"
import script from "./HomeMakAndGreet.vue?vue&type=script&lang=js"
export * from "./HomeMakAndGreet.vue?vue&type=script&lang=js"
import "./HomeMakAndGreet.vue?vue&type=style&index=0&id=87b9ec58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports